import {ActionTree} from 'vuex';
import {WidgetState} from '@/modules/widget/store/index';
import {RootState} from '@/store/types';
import {MutationTypes} from '@/modules/widget/store/mutations';
import * as api from '@/modules/widget/api'
import {VueGridLayoutWidget} from '@/modules/widget/support';

const actions: ActionTree<WidgetState, RootState> = {
    /**
     * Carga en el estado la lista de widgets del usuario actual
     */
    async loadWidgetLayout ({commit, getters}) {
        const widgets = await api.getWidgets()
        // Inserta en la entidad del widget el tipo de widget correcto
        widgets.forEach(widget => {
            const type = getters.widgetType(widget.typeName)
            if (!type) {
                throw new Error(`No existe ningún tipo de widget para ${widget.typeName}`)
            }

            widget.type = type
        })

        commit(MutationTypes.SetWidgets, widgets)
    },

    /**
     * Toma como payload la lista de widgets cargados en el layout virtual del
     * tablero y actualiza el layout que se encuentra en el estado de la
     * aplicación para luego informar el servidor del cambio
     * realizado por el usuario
     */
    async updateWidgetLayout ({commit, state}, virtualLayout: VueGridLayoutWidget[]) {
        virtualLayout.forEach(virtualWidget => {
            commit(MutationTypes.UpdateWidget, {
                id: virtualWidget.i,
                x: virtualWidget.x,
                y: virtualWidget.y,
                h: virtualWidget.h,
                w: virtualWidget.w,
            })
        })

        await api.updateLayout(state.layout)
    },

    /**
     * Actualiza el estado de un widget
     *
     * @param state
     * @param id
     */
    async updateWidgetState ({state}, id: number) {
        const widget = state.layout.find(w => w.id === id) || null
        if (!widget) {
            throw new Error(`No se puede actualizar el estado del widget ${id} porque no existe`)
        }

        api.updateWidgetState(id, widget.state)
    },
}

export default actions
